<template>
  <div class="container is-fluid container-margin-top">
    <div class="content content-padding">
      <h1>Screensaver do Coche</h1>

      <div class="columns">
        <div class="column is-half" v-if="coach && coach.screensaver_path">
          <label class="label">Video</label>
          <video width="100%" height="100%" controls>
            <source :src="screensaverLocation + coach.screensaver_path" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      <a class="button is-primary" @click="openCoachScreensaverModal" v-if="coach && !coach.screensaver_path">
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>Adicionar</span>
      </a>
      <a class="button is-primary" @click="openCoachScreensaverModal" v-if="coach && coach.screensaver_path">
        <span class="icon">
          <i class="fa fa-edit"></i>
        </span>
        <span>Editar</span>
      </a>
    </div>
  </div>
</template>

<script>
  import { COACH_SAVER_PATH } from '../../config'
  import Vue from 'vue'
  import CoachScreensaverModal from './CoachScreensaverModal'

  const CoachScreensaverModalComponent = Vue.extend(CoachScreensaverModal)

  export default {
    components: {
    },

    props: ['coach'],

    data () {
      return {
        screensaverLocation: COACH_SAVER_PATH
      }
    },

    mounted () {
    },

    computed: {
      currentEvent () {
        return window.store.state.event.nextEvent
      }
    },

    methods: {
      openCoachScreensaverModal () {
        let openCardModal = (propsData = {}) => {
          return new CoachScreensaverModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModal({
          title: 'Editar Screensaver',
          coach: this.coach.id,
          video: this.coach.screensaver_path
        })
      }
    },

    watch: {
      currentEvent: function (val) {
      }
    }
  }
</script>

<style lang="scss">
  .flexbox-grid {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
</style>


// WEBPACK FOOTER //
// CoachScreensaver.vue?1b6effe3